export default {
  name: "n-sms",
  props: {
    visible: Boolean,
    phone: String,
    busType: Number,
  },
  data() {
    return {
      ruleForm: {
        code: "",
        mobile: this.phone,
        type: this.busType,
      },
      rules: {
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "请输入正确的验证码",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
      },
      mobileReadonly: false,
      timer: null,
      countDown: 60,
      codeDisiable: false,
    };
  },
  watch: {
    phone(value) {
      this.ruleForm.mobile = value;
      this.mobileReadonly = true;
    },
    busType(value) {
      this.ruleForm.type = value;
    },
    visible(value) {
      if (value) {
        this.ruleForm.code = "";
        this.timer && clearInterval(this.timer);
        this.codeDisiable = false;
        this.countDown = 60;
      }
    },
  },
  methods: {
    getSms() {
      this.$refs.ruleForm.validateField("mobile", (errorMessage) => {
        if (this.codeDisiable || errorMessage) {
          return;
        }
        this.$store.dispatch("sms/generateCaptcha", { phone: this.ruleForm.mobile, busType: this.ruleForm.type }).then(() => {});
        this.codeDisiable = true;
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.countDown = this.countDown - 1;
          if (this.countDown <= 0) {
            this.timer && clearInterval(this.timer);
            this.codeDisiable = false;
            this.countDown = 60;
          }
        }, 1000);
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.warning("请输入验证码");
          return;
        }
        this.$store
          .dispatch("sms/submitCaptcha", {
            phone: this.ruleForm.mobile,
            busType: this.ruleForm.type,
            codeNum: this.ruleForm.code,
          })
          .then((res) => {
            if (res.code == "1") {
              this.$store.dispatch("sms/delCaptcha", { phone: this.ruleForm.mobile, busType: this.ruleForm.type }).then(() => {});
              this.$emit("submitClick");
            } else if (res.code == "-1") {
              this.$message.warning("验证码错误");
            } else if (res.code == "-2") {
              this.$message.warning("验证码已失效");
            } else {
              this.$message.warning("请重新获取验证码");
            }
          });
      });
    },
  },
};
